import { render, staticRenderFns } from "./SvgFileInput.vue?vue&type=template&id=6a7bb9f0&scoped=true"
import script from "./SvgFileInput.vue?vue&type=script&lang=js"
export * from "./SvgFileInput.vue?vue&type=script&lang=js"
import style0 from "./SvgFileInput.vue?vue&type=style&index=0&id=6a7bb9f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7bb9f0",
  null
  
)

export default component.exports